import { Pipe } from '@angular/core';

@Pipe({
    name: 'trunc'
})
export class TruncPipe {
    // Autocapitalizes the first letter of each word in a phrase.
    // Input: {{'john doe' | capitalize}}
    // Output: John Doe
    transform(value, qtdCasas = 0) {
        var fator = Math.pow(10, qtdCasas);
        return Math.trunc(value * fator) / fator;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/trunc.pipe.ts